import React from 'react';
import styled from 'styled-components';
import { FaArrowLeft, FaHome } from 'react-icons/fa';
import { colors } from '../../../../assets/styles/GlobalStyles';

const Barra = styled.nav`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 1.5rem;
`;

// Mesmo visual do "Voltar" da tela de lista de pedidos (SelecaoPedidoPage).
const BotaoNav = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: white;
  border: 1px solid #e1e4e8;
  border-radius: 12px;
  color: ${colors.darkBlue};
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 500;
  padding: 0.6rem 1.2rem;
  transition: all 0.3s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);

  &:hover {
    background: ${colors.lightBlue};
    border-color: ${colors.lightBlue};
    color: white;
    box-shadow: 0 4px 12px rgba(37, 99, 128, 0.15);
  }

  @media (max-width: 480px) {
    flex: 1 1 100%;
    justify-content: center;
  }
`;

// Atalhos no topo de todo pedido: voltar pra lista de pedidos do departamento
// ou pra Home. O progresso já fica salvo no navegador (rascunhoPedidoService),
// então sair por aqui não perde o que foi preenchido.
const NavegacaoPedido = ({ nomeDepartamento, onVoltarPedidos, onVoltarHome }) => (
  <Barra aria-label="Navegação do pedido">
    <BotaoNav type="button" onClick={onVoltarPedidos}>
      <FaArrowLeft aria-hidden="true" />
      Voltar para {nomeDepartamento || 'os pedidos'}
    </BotaoNav>
    <BotaoNav type="button" onClick={onVoltarHome}>
      <FaHome aria-hidden="true" />
      Página inicial
    </BotaoNav>
  </Barra>
);

export default NavegacaoPedido;
